




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {GetClaimsNo} from 'supporter';
import {isExchangeRejectRequest, isReturnRejectRequest} from '@/components/claim/popup/validations';
import {ClaimType} from '@/types/claim';

@Component({
  computed: {
    isReturnRejectRequest,
    isExchangeRejectRequest,
    redBigStyle(){
      return this.isExchangeRejectRequest ?
        'red big' : ''
    }
  }
})
export default class ReturnWithdrawReason extends Vue{
  @Prop({required: true})
  private readonly claimType!: ClaimType

  @Prop({required: true})
  private readonly claimNoResponseData!: GetClaimsNo
}
